import { useEffect } from "react";
import './index.less'
import wx from "weixin-js-sdk";
import { SpinLoading } from 'antd-mobile'

const VerifiPage = (props:any) => {
  useEffect(() => {
    // setTimeout(() => {
      wx.miniProgram.navigateBack({ url: '/pages_auth/index/index' })
    // }, 3000)
  }, []);

  return (
    <div className='verifi-page'>
      <SpinLoading style={{ '--size': '48px' }} />
    </div>
  )
}

export default VerifiPage